var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldStyled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.348,
    height: 17.436,
    viewBox: "0 0 16.348 17.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.shield-icon{fill:#f8821c;}\n\t\t"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "shield-icon",
    d: "M16.468,2.852,9.929.127a1.64,1.64,0,0,0-1.257,0L2.133,2.852A1.633,1.633,0,0,0,1.125,4.36c0,6.761,3.9,11.433,7.544,12.952a1.64,1.64,0,0,0,1.257,0C12.845,16.1,17.473,11.9,17.473,4.36A1.635,1.635,0,0,0,16.468,2.852Z",
    transform: "translate(-1.125 -0.002)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldStyled);
export default __webpack_public_path__ + "static/media/ShieldStyled.1f9a836addcef33cff534b66923d4ed2.svg";
export { ForwardRef as ReactComponent };